import PopupGeoZoneIcon from './component'

export default PopupGeoZoneIcon
